<template>
  <div>
    <el-tabs type="border-card" v-if="Array.isArray(form.locationReportNode)">
      <template v-for="(item, index) in form.locationReportNode">
        <el-tab-pane :label="item" :key="index">
          <slot></slot>
        </el-tab-pane>
      </template>
    </el-tabs>
    <template class="py-4" v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>
